import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface AlertData {
  id?: string;
  type: string;
  title: string;
  message: string;
  dismissable: boolean;
  timestamp?: number;
}

@Injectable({
  providedIn: 'root'
})
export class AlertCommunicationService {
  private alertSubject = new Subject<AlertData>();
  private alerts: AlertData[] = [];
  private alertIdCounter = 0;

  constructor() {}

  getAlertsObservable(): Observable<AlertData> {
    return this.alertSubject.asObservable();
  }

  // Add a new alert
  addAlert(alert: Partial<AlertData>): void {
    const newAlert: AlertData = {
      id: alert.id || `alert-${++this.alertIdCounter}`,
      type: alert.type || 'info',
      title: alert.title || '',
      message: alert.message || '',
      dismissable: alert.dismissable !== false,
      timestamp: Date.now()
    };

    this.alerts.push(newAlert);
    this.alertSubject.next(newAlert);
  }
}
